import React from "react";

const VipLevelInfo = ({ userObject }) => {
  return (
    <div className="gray-bg-border mt-3">
      <div className="d-flex justify-content-between gap-2">
        <h6 className="dark-gray f-bold">Loyalty Program Info:</h6>
        <h6 className="darkgray"></h6>
      </div>

      <p class="darkgray f-bold mb-2">
        <span class="f-bold"> Level Name : </span>{" "}
        <span class="normal-w"> {userObject?.casinobench?.packagename} </span>{" "}
      </p>
      <p class="darkgray f-bold mb-2">
        <span class="f-bold">Gift Delivery : </span>{" "}
        <span class="normal-w">{userObject?.casinobench?.gift_delivery}</span>{" "}
      </p>
      <p class="darkgray f-bold mb-2">
        <span class="f-bold">Free Spins: </span>{" "}
        <span class="normal-w">{userObject?.casinobench?.free_spins}</span>{" "}
      </p>
      <p class="darkgray f-bold mb-2">
        <span class="f-bold">Cash Redemption : </span>{" "}
        <span class="normal-w">{userObject?.casinobench?.cash_redemption}</span>{" "}
      </p>
    </div>
  );
};

export default VipLevelInfo;
